import React, { Component } from 'react';
import { Redirect, Switch, Route } from 'react-router-dom';
import DashboardLayout from '../layouts/DashboardLayout';
import ErrorLayout from '../layouts/ErrorLayout';
import * as firebase from 'firebase/app';
import 'firebase/auth';
import SpinnerModal from '../components/common/SpinnerModal';
import Login from '../components/auth/split/Login';
import WhiteListService from '../services/WhiteList/WhiteListService';
import { UserContext } from '../Contexts';
import AuthenticationService from '../services/Authentication/AuthenticationService';
import UserService from '../services/User/UserService';
import FeatureService from '../services/Feature/FeatureService';

import loadable from '@loadable/component';
import { whitelistedBasePaths } from '../routes';
const DashboardRoutes = loadable(() => import('../layouts/DashboardRoutes'));

const allowedInbdeRoutes = whitelistedBasePaths;

class LandingPage extends Component {
  _isMounted = false;
  whiteListService = new WhiteListService();
  authenticationService = new AuthenticationService();
  unsubscribe;
  userService = new UserService();
  featureService = new FeatureService();

  constructor(props) {
    super(props);

    this.state = {
      isUserAuthenticated: false,
      isLoading: false,
      userAccess: 'faculty',
      user: null,
      email: '',
      admins: [],
      toggles: {}
    };
  }

  componentDidMount() {
    // eslint-disable-next-line react/prop-types
    const { history, location } = this.props;
    // eslint-disable-next-line react/prop-types
    history.push(location.pathname);

    this._isMounted = true;
    this.setState({ isLoading: true });

    DashboardRoutes.preload();

    // LOCAL DEMO MODE ONLY: skip Google/Firebase sign-in and log in a local
    // demo user against the Firebase emulator. Never enabled in deployed builds.
    if (process.env.REACT_APP_DEMO_LOCAL === 'true') {
      this.applicationContext({
        email: 'demo@nyu.edu',
        uid: 'demo-user',
        phoneNumber: null,
        displayName: 'Demo User',
        photoURL: null,
        google_id_token: null
      });
      return;
    }

    this.unsubscribe = firebase.auth().onAuthStateChanged(firebaseUser => {
      if (firebaseUser) {
        // User is signed in to firebase.
        this.userService.isUserLoggedIn(firebaseUser.uid, false, data => {
          if (data && data.is_logged_in) {
            const { full_name: displayName, image_url: photoURL, google_id_token } = data;
            const { email, uid, phoneNumber } = firebaseUser;
            this.applicationContext({ email, uid, phoneNumber, displayName, photoURL, google_id_token });
          } else {
            this._isMounted &&
              this.setState({
                isUserAuthenticated: false,
                isLoading: false,
                userAccess: 'faculty',
                user: null,
                email: ''
              });
          }
        });
      } else {
        // No user is signed in.
        this.userService.isUserLoggedIn(null, true, () => {});
        this._isMounted &&
          this.setState({
            isUserAuthenticated: false,
            isLoading: false,
            userAccess: 'faculty',
            user: null,
            email: ''
          });
      }
    });
  }

  componentWillUnmount() {
    this.unsubscribe && this.unsubscribe();
    this._isMounted = false;
  }

  applicationContext(loggedInUser) {
    const email = loggedInUser.email;
    this.whiteListService.getWhiteListEntry(email, false, async data => {
      if (data) {
        let user = loggedInUser;
        user.access_type = data.access_type;

        const admins = await this.userService.getListOfAdmins();
        this.featureService.getListOfToggles(false, toggleList => {
          this._isMounted &&
            this.setState({
              userAccess: data.access_type,
              isLoading: false,
              isUserAuthenticated: true,
              email,
              user,
              admins,
              toggles: toggleList ? toggleList : {}
            });
        });
      } else {
        // comment out the two lines below to show user logged in app but without whitelist
        this._isMounted && this.setState({ isLoading: true });
        this.signOutUser();
      }
    });
  }

  signOutUser() {
    const { user, email } = this.state;

    user && this.userService.isUserLoggedIn(user.uid, true, () => {});
    email && this.whiteListService.getWhiteListEntry(email, true, () => {});
    this.featureService.getListOfToggles(true, () => {});
    this.authenticationService.signOutOfFirebase();
    this._isMounted &&
      this.setState({
        isUserAuthenticated: false,
        isLoading: false,
        userAccess: 'faculty',
        user: null,
        email: ''
      });
  }

  render() {
    const { isUserAuthenticated, isLoading, userAccess, user, admins, toggles } = this.state;

    return (
      <>
        {isLoading && <SpinnerModal />}
        {isUserAuthenticated ? (
          <UserContext.Provider value={{ user, admins, toggles }}>
            <Switch>
              <Route path="/errors" component={ErrorLayout} />
              <Route
                path={allowedInbdeRoutes}
                render={props => <DashboardLayout {...props} userAccess={userAccess} />}
              />
              <Route
                path="/"
                exact
                render={() => {
                  return <Redirect to="/search" />;
                }}
              />
              <Redirect to="/errors/404" />
            </Switch>
          </UserContext.Provider>
        ) : (
          <>
            <Redirect to="/" />
            <Login />
          </>
        )}
      </>
    );
  }
}

export default LandingPage;
